import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const login = (username, password) => {
  return api.post(`${ApiEndpointConstants.LOGIN}`, { username, password });
};
